module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "partner"
  }, [(_vm.step > 0) ? _c('div', {
    staticClass: "progressNum"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.step == 1
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "step_divider"
  }), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 2
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 0) ? _c('div', {
    staticClass: "step"
  }, [_c('h2', {
    staticClass: "center"
  }, [_vm._v("ARE YOU AN INDIVIDUAL OR A COMPANY?")]), _vm._v(" "), _c('a', {
    staticClass: "button btn-step0",
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('SelectLegalType', 'individual')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('individual').tUpper()))]), _vm._v(" "), _c('a', {
    staticClass: "button btn-step0",
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('SelectLegalType', 'company')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('company').tUpper()))])]) : _vm._e(), _vm._v(" "), (_vm.step == 1 && _vm.legalType == 'individual') ? _c('div', {
    staticClass: "step"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('personal_information').tUpper()))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "title"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.title))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.title),
      expression: "body.title"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('title')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.title,
      "name": "title"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.titles), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(item))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('title')),
      expression: "errors.has('title')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('title')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.firstname))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.firstname),
      expression: "body.firstname"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('firstname')
    },
    attrs: {
      "name": "firstname",
      "type": "text",
      "data-vv-as": _vm.translations.text.firstname,
      "placeholder": _vm.translations.text.firstname
    },
    domProps: {
      "value": (_vm.body.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('firstname')),
      expression: "errors.has('firstname')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('firstname')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.lastname))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.lastname),
      expression: "body.lastname"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('lastname')
    },
    attrs: {
      "name": "lastname",
      "type": "text",
      "data-vv-as": _vm.translations.text.lastname,
      "placeholder": _vm.translations.text.lastname
    },
    domProps: {
      "value": (_vm.body.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lastname')),
      expression: "errors.has('lastname')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('lastname')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.email))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|email-available'),
      expression: "'required|email|email-available'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.email),
      expression: "body.email"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "text",
      "data-vv-as": _vm.translations.text.email,
      "placeholder": _vm.translations.text.email
    },
    domProps: {
      "value": (_vm.body.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "country"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.country))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.country),
      expression: "body.country"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('country')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.country,
      "name": "country"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.checkIfIsEuropeanCountry]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.filteredCountries), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('country')),
      expression: "errors.has('country')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('country')))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns column"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.phone))]), _vm._v(" "), _c('div', {
    staticClass: "control relative"
  }, [_c('div', {
    staticClass: "dialcodeBox"
  }, [_vm._v(_vm._s(_vm.body.country != '' ? _vm.body.dialCode : ''))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.phone),
      expression: "body.phone"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('phone'), 'push-left': _vm.body.country != ''
    },
    attrs: {
      "name": "phone",
      "type": "text",
      "data-vv-as": _vm.translations.text.phone,
      "placeholder": _vm.translations.text.phone
    },
    domProps: {
      "value": (_vm.body.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])])])])]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-pulled-right next",
    on: {
      "click": _vm.nextStep
    }
  }, [_c('span', [_vm._v("NEXT")])])]) : _vm._e(), _vm._v(" "), (_vm.step == 1 && _vm.legalType == 'company') ? _c('div', {
    staticClass: "step"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('company_information').tUpper()))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "company_name"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.company_name))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.company_name),
      expression: "body.company_name"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('company_name')
    },
    attrs: {
      "name": "company_name",
      "type": "text",
      "data-vv-as": _vm.translations.text.company_name,
      "placeholder": _vm.translations.text.company_name
    },
    domProps: {
      "value": (_vm.body.company_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "company_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('company_name')),
      expression: "errors.has('company_name')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('company_name')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "website"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.company_website))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.website),
      expression: "body.website"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('website')
    },
    attrs: {
      "name": "website",
      "type": "text",
      "data-vv-as": _vm.translations.text.company_website,
      "placeholder": _vm.translations.text.website
    },
    domProps: {
      "value": (_vm.body.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "website", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('website')),
      expression: "errors.has('website')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('website')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "skype_id"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.skype_id))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.skype_id),
      expression: "body.skype_id"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('skype_id')
    },
    attrs: {
      "name": "skype_id",
      "type": "text",
      "data-vv-as": _vm.translations.text.skype_id,
      "placeholder": _vm.translations.text.skype_id
    },
    domProps: {
      "value": (_vm.body.skype_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "skype_id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('skype_id')),
      expression: "errors.has('skype_id')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('skype_id')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "country"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.country))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.country),
      expression: "body.country"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('country')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.country,
      "name": "country"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.checkIfIsEuropeanCountry]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.filteredCountries), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('country')),
      expression: "errors.has('country')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('country')))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns column"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.phone))]), _vm._v(" "), _c('div', {
    staticClass: "control relative"
  }, [_c('div', {
    staticClass: "dialcodeBox"
  }, [_vm._v(_vm._s(_vm.body.country != '' ? _vm.body.dialCode : ''))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.phone),
      expression: "body.phone"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('phone'), 'push-left': _vm.body.country != ''
    },
    attrs: {
      "name": "phone",
      "type": "text",
      "data-vv-as": _vm.translations.text.phone,
      "placeholder": _vm.translations.text.phone
    },
    domProps: {
      "value": (_vm.body.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])])])])]), _vm._v(" "), _c('h2', {
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('company_registration_information').tUpper()))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "dob"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.date_of_registration))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label is-small",
    attrs: {
      "for": "dob_day"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.day))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.dob.day),
      expression: "body.dob.day"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('dob_day')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.day,
      "name": "dob_day"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body.dob, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.monthDayIndexes), function(day) {
    return _c('option', {
      key: day,
      domProps: {
        "value": day
      }
    }, [_vm._v(_vm._s(day))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dob_day')),
      expression: "errors.has('dob_day')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('dob_day')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label is-small",
    attrs: {
      "for": "dob_month"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.month))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.dob.month),
      expression: "body.dob.month"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('dob_month')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.month,
      "name": "dob_month"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body.dob, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.translations.months), function(month, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(month))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dob_month')),
      expression: "errors.has('dob_month')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('dob_month')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label is-small",
    attrs: {
      "for": "dob_year"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.year))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.dob.year),
      expression: "body.dob.year"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('dob_year')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.year,
      "name": "dob_year"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body.dob, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return _c('option', {
      key: year,
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dob_year')),
      expression: "errors.has('dob_year')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('dob_year')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.address))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.address),
      expression: "body.address"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('address')
    },
    attrs: {
      "name": "address",
      "type": "text",
      "data-vv-as": _vm.translations.text.address,
      "placeholder": _vm.translations.text.address
    },
    domProps: {
      "value": (_vm.body.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('address')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "address2"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.address2))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.address2),
      expression: "body.address2"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('address2')
    },
    attrs: {
      "name": "address2",
      "type": "text",
      "data-vv-as": _vm.translations.text.address2,
      "placeholder": _vm.translations.text.address2
    },
    domProps: {
      "value": (_vm.body.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "address2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address2')),
      expression: "errors.has('address2')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('address2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "post_code"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.post_code))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.post_code),
      expression: "body.post_code"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('post_code')
    },
    attrs: {
      "name": "post_code",
      "type": "text",
      "data-vv-as": _vm.translations.text.post_code,
      "placeholder": _vm.translations.text.post_code
    },
    domProps: {
      "value": (_vm.body.post_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "post_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('post_code')),
      expression: "errors.has('post_code')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('post_code')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "city"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.city))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.city),
      expression: "body.city"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('city')
    },
    attrs: {
      "name": "city",
      "type": "text",
      "data-vv-as": _vm.translations.text.city,
      "placeholder": _vm.translations.text.city
    },
    domProps: {
      "value": (_vm.body.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('city')),
      expression: "errors.has('city')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('city')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "state_province"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.state_province))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.state_province),
      expression: "body.state_province"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('state_province')
    },
    attrs: {
      "name": "state_province",
      "type": "text",
      "data-vv-as": _vm.translations.text.state_province,
      "placeholder": _vm.translations.text.state_province
    },
    domProps: {
      "value": (_vm.body.state_province)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "state_province", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state_province')),
      expression: "errors.has('state_province')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('state_province')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    attrs: {
      "for": "year_moved_to_address"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.year_moved_to_address))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.year_moved_to_address),
      expression: "body.year_moved_to_address"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('year_moved_to_address')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.year_moved_to_address,
      "name": "year_moved_to_address"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "year_moved_to_address", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return _c('option', {
      key: year,
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('year_moved_to_address')),
      expression: "errors.has('year_moved_to_address')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('year_moved_to_address')))])])])]), _vm._v(" "), _c('h2', {
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('login_information').tUpper()))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.email))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|email-available'),
      expression: "'required|email|email-available'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.email),
      expression: "body.email"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "text",
      "data-vv-as": _vm.translations.text.email,
      "placeholder": _vm.translations.text.email
    },
    domProps: {
      "value": (_vm.body.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.password))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|strong-password|confirmed:confirm_password'),
      expression: "'required|strong-password|confirmed:confirm_password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.password),
      expression: "body.password"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('password')
    },
    attrs: {
      "name": "password",
      "type": "password",
      "data-vv-as": _vm.translations.text.password,
      "placeholder": _vm.translations.text.password
    },
    domProps: {
      "value": (_vm.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "confirm_password"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.confirm_password))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.confirm_password),
      expression: "body.confirm_password"
    }],
    ref: "confirm_password",
    class: {
      'input': true, 'is-danger': _vm.errors.has('confirm_password')
    },
    attrs: {
      "name": "confirm_password",
      "type": "password",
      "data-vv-as": _vm.translations.text.confirm_password,
      "placeholder": _vm.translations.text.confirm_password
    },
    domProps: {
      "value": (_vm.body.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "confirm_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirm_password')),
      expression: "errors.has('confirm_password')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('confirm_password')))])])])]), _vm._v(" "), _c('a', {
    staticClass: "button is-dark is-pulled-left previous",
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('PreviousStep', $event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("previous")))])]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-pulled-right next",
    on: {
      "click": _vm.nextStep
    }
  }, [_c('span', [_vm._v("NEXT")])])]) : _vm._e(), _vm._v(" "), (_vm.step == 2 && _vm.legalType == 'individual') ? _c('div', {
    staticClass: "step"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('personal_information').tUpper()))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "dob"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.date_of_birth))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label is-small",
    attrs: {
      "for": "dob_day"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.day))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.dob.day),
      expression: "body.dob.day"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('dob_day')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.day,
      "name": "dob_day"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body.dob, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.monthDayIndexes), function(day) {
    return _c('option', {
      key: day,
      domProps: {
        "value": day
      }
    }, [_vm._v(_vm._s(day))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dob_day')),
      expression: "errors.has('dob_day')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('dob_day')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label is-small",
    attrs: {
      "for": "dob_month"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.month))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.dob.month),
      expression: "body.dob.month"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('dob_month')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.month,
      "name": "dob_month"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body.dob, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.translations.months), function(month, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(month))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dob_month')),
      expression: "errors.has('dob_month')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('dob_month')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label is-small",
    attrs: {
      "for": "dob_year"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.year))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        'is-over-18': _vm.body.dob.day + '-' + _vm.body.dob.month + '-' + _vm.body.dob.year
      }),
      expression: "{ required: true, 'is-over-18': body.dob.day + '-' + body.dob.month + '-' + body.dob.year }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.dob.year),
      expression: "body.dob.year"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('dob_year')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.year,
      "name": "dob_year"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body.dob, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return _c('option', {
      key: year,
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dob_year')),
      expression: "errors.has('dob_year')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('dob_year')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ib_main_target_region"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.target_geo_location))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.ib_main_target_region),
      expression: "body.ib_main_target_region"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('ib_main_target_region')
    },
    attrs: {
      "name": "ib_main_target_region",
      "type": "text",
      "data-vv-as": _vm.translations.text.target_geo_location,
      "placeholder": _vm.translations.text.target_geo_location
    },
    domProps: {
      "value": (_vm.body.ib_main_target_region)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "ib_main_target_region", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ib_main_target_region')),
      expression: "errors.has('ib_main_target_region')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('ib_main_target_region')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "gender"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.gender))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.gender),
      expression: "body.gender"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('gender')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.gender,
      "name": "gender"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.translations.genders), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(item))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('gender')),
      expression: "errors.has('gender')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('gender')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.address))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.address),
      expression: "body.address"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('address')
    },
    attrs: {
      "name": "address",
      "type": "text",
      "data-vv-as": _vm.translations.text.address,
      "placeholder": _vm.translations.text.address
    },
    domProps: {
      "value": (_vm.body.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('address')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "address2"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.address2))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.address2),
      expression: "body.address2"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('address2')
    },
    attrs: {
      "name": "address2",
      "type": "text",
      "data-vv-as": _vm.translations.text.address2,
      "placeholder": _vm.translations.text.address2
    },
    domProps: {
      "value": (_vm.body.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "address2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address2')),
      expression: "errors.has('address2')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('address2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "post_code"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.post_code))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.post_code),
      expression: "body.post_code"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('post_code')
    },
    attrs: {
      "name": "post_code",
      "type": "text",
      "data-vv-as": _vm.translations.text.post_code,
      "placeholder": _vm.translations.text.post_code
    },
    domProps: {
      "value": (_vm.body.post_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "post_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('post_code')),
      expression: "errors.has('post_code')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('post_code')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "city"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.city))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.city),
      expression: "body.city"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('city')
    },
    attrs: {
      "name": "city",
      "type": "text",
      "data-vv-as": _vm.translations.text.city,
      "placeholder": _vm.translations.text.city
    },
    domProps: {
      "value": (_vm.body.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('city')),
      expression: "errors.has('city')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('city')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "state_province"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.state_province))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.state_province),
      expression: "body.state_province"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('state_province')
    },
    attrs: {
      "name": "state_province",
      "type": "text",
      "data-vv-as": _vm.translations.text.state_province,
      "placeholder": _vm.translations.text.state_province
    },
    domProps: {
      "value": (_vm.body.state_province)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "state_province", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state_province')),
      expression: "errors.has('state_province')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('state_province')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    attrs: {
      "for": "year_moved_to_address"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.year_moved_to_address))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.year_moved_to_address),
      expression: "body.year_moved_to_address"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('year_moved_to_address')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.year_moved_to_address,
      "name": "year_moved_to_address"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "year_moved_to_address", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return _c('option', {
      key: year,
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('year_moved_to_address')),
      expression: "errors.has('year_moved_to_address')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('year_moved_to_address')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "website"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.website))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.website),
      expression: "body.website"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('website')
    },
    attrs: {
      "name": "website",
      "type": "text",
      "data-vv-as": _vm.translations.text.website,
      "placeholder": _vm.translations.text.website
    },
    domProps: {
      "value": (_vm.body.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "website", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('website')),
      expression: "errors.has('website')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('website')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "skype_id"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.skype_id))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.skype_id),
      expression: "body.skype_id"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('skype_id')
    },
    attrs: {
      "name": "skype_id",
      "type": "text",
      "data-vv-as": _vm.translations.text.skype_id,
      "placeholder": _vm.translations.text.skype_id
    },
    domProps: {
      "value": (_vm.body.skype_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "skype_id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('skype_id')),
      expression: "errors.has('skype_id')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('skype_id')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.password))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|strong-password|confirmed:confirm_password'),
      expression: "'required|strong-password|confirmed:confirm_password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.password),
      expression: "body.password"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('password')
    },
    attrs: {
      "name": "password",
      "type": "password",
      "data-vv-as": _vm.translations.text.password,
      "placeholder": _vm.translations.text.password
    },
    domProps: {
      "value": (_vm.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "confirm_password"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.confirm_password))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.confirm_password),
      expression: "body.confirm_password"
    }],
    ref: "confirm_password",
    class: {
      'input': true, 'is-danger': _vm.errors.has('confirm_password')
    },
    attrs: {
      "name": "confirm_password",
      "type": "password",
      "data-vv-as": _vm.translations.text.confirm_password,
      "placeholder": _vm.translations.text.confirm_password
    },
    domProps: {
      "value": (_vm.body.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "confirm_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirm_password')),
      expression: "errors.has('confirm_password')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('confirm_password')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "control",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.tos_with_link),
      expression: "body.tos_with_link"
    }],
    staticClass: "agreements",
    class: {
      'is-danger': _vm.errors.has('include_account_in_bonus_program')
    },
    attrs: {
      "name": "tos_with_link",
      "type": "checkbox",
      "data-vv-as": _vm.translations.text.tos_with_link
    },
    domProps: {
      "checked": Array.isArray(_vm.body.tos_with_link) ? _vm._i(_vm.body.tos_with_link, null) > -1 : (_vm.body.tos_with_link)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.body.tos_with_link,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.body, "tos_with_link", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.body, "tos_with_link", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.body, "tos_with_link", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.translations.text.tos_with_link)
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tos_with_link')),
      expression: "errors.has('tos_with_link')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tos_with_link')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.agree_terms_marketing),
      expression: "body.agree_terms_marketing"
    }],
    staticClass: "agreements",
    class: {
      'is-danger': _vm.errors.has('agree_terms_marketing')
    },
    attrs: {
      "name": "agree_terms_marketing",
      "type": "checkbox",
      "data-vv-as": _vm.translations.text.agree_terms_marketing
    },
    domProps: {
      "checked": Array.isArray(_vm.body.agree_terms_marketing) ? _vm._i(_vm.body.agree_terms_marketing, null) > -1 : (_vm.body.agree_terms_marketing)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.body.agree_terms_marketing,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.body, "agree_terms_marketing", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.body, "agree_terms_marketing", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.body, "agree_terms_marketing", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.translations.text.agree_terms_marketing)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "control privacy_data_text",
    domProps: {
      "innerHTML": _vm._s(_vm.translations.text.data_policy_text)
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "button is-dark is-pulled-left previous",
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('PreviousStep', $event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("previous")))])]), _vm._v(" "), _c('a', {
    staticClass: "button is-success is-pulled-right is-medium next",
    class: [_vm.isDisabled ? 'disabledButton' : ''],
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.validateCaptcha
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("complete")))])])]) : _vm._e(), _vm._v(" "), (_vm.step == 2 && _vm.legalType == 'company') ? _c('div', {
    staticClass: "step"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('company_shareholders_directors').tUpper()))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ib_main_target_region"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.target_geo_location))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.ib_main_target_region),
      expression: "body.ib_main_target_region"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('ib_main_target_region')
    },
    attrs: {
      "name": "ib_main_target_region",
      "type": "text",
      "data-vv-as": _vm.translations.text.target_geo_location,
      "placeholder": _vm.translations.text.target_geo_location
    },
    domProps: {
      "value": (_vm.body.ib_main_target_region)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "ib_main_target_region", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ib_main_target_region')),
      expression: "errors.has('ib_main_target_region')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('ib_main_target_region')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label is-small",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    attrs: {
      "for": "numberOfShareholders"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.number_of_shareholders))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.numberOfShareholders),
      expression: "numberOfShareholders"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('numberOfShareholders')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.number_of_shareholders,
      "name": "numberOfShareholders"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.numberOfShareholders = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numberOfShareholders')),
      expression: "errors.has('numberOfShareholders')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('numberOfShareholders')))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label is-small",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    attrs: {
      "for": "numberOfDirectors"
    }
  }, [_vm._v(_vm._s(_vm.translations.text.number_of_directors))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.numberOfDirectors),
      expression: "numberOfDirectors"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('numberOfDirectors')
    },
    attrs: {
      "data-vv-as": _vm.translations.text.number_of_directors,
      "name": "numberOfDirectors"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.numberOfDirectors = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numberOfDirectors')),
      expression: "errors.has('numberOfDirectors')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('numberOfDirectors')))])])])]), _vm._v(" "), _vm._l((_vm.body.shareholders), function(person, index) {
    return _c('div', {
      key: 'share-' + index,
      staticClass: "shareholders-directors"
    }, [_c('h2', [_vm._v(_vm._s(_vm.$t('shareholder').tUpper()) + " - " + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "firstname"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.firstname))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|alpha_spaces'),
        expression: "'required|alpha_spaces'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.firstname),
        expression: "person.firstname"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('sh-firstname_' + index)
      },
      attrs: {
        "name": 'sh-firstname_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.firstname,
        "placeholder": _vm.translations.text.firstname
      },
      domProps: {
        "value": (person.firstname)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "firstname", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('sh-firstname_' + index)),
        expression: "errors.has('sh-firstname_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('sh-firstname_' + index)))])])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "lastname"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.lastname))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|alpha_spaces'),
        expression: "'required|alpha_spaces'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.lastname),
        expression: "person.lastname"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('sh-lastname_' + index)
      },
      attrs: {
        "name": 'sh-lastname_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.lastname,
        "placeholder": _vm.translations.text.lastname
      },
      domProps: {
        "value": (person.lastname)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "lastname", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('sh-lastname_' + index)),
        expression: "errors.has('sh-lastname_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('sh-lastname_' + index)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "dob"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.date_of_birth))])])]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label is-small",
      attrs: {
        "for": "dob_day"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.day))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select is-fullwidth"
    }, [_c('select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.dob.day),
        expression: "person.dob.day"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('sh-dob_day_' + index)
      },
      attrs: {
        "data-vv-as": _vm.translations.text.day,
        "name": 'sh-dob_day_' + index
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(person.dob, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.monthDayIndexes), function(day) {
      return _c('option', {
        key: day,
        domProps: {
          "value": day
        }
      }, [_vm._v(_vm._s(day))])
    })], 2)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('sh-dob_day_' + index)),
        expression: "errors.has('sh-dob_day_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('sh-dob_day_' + index)))])])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label is-small",
      attrs: {
        "for": "dob_month"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.month))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select is-fullwidth"
    }, [_c('select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.dob.month),
        expression: "person.dob.month"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('sh-dob_month_' + index)
      },
      attrs: {
        "data-vv-as": _vm.translations.text.month,
        "name": 'sh-dob_month_' + index
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(person.dob, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.translations.months), function(month, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": index
        }
      }, [_vm._v(_vm._s(month))])
    })], 2)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('sh-dob_month_' + index)),
        expression: "errors.has('sh-dob_month_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('sh-dob_month_' + index)))])])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label is-small",
      attrs: {
        "for": "dob_year"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.year))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select is-fullwidth"
    }, [_c('select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true,
          'is-over-18': person.dob.day + '-' + person.dob.month + '-' + person.dob.year
        }),
        expression: "{ required: true, 'is-over-18': person.dob.day + '-' + person.dob.month + '-' + person.dob.year }"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.dob.year),
        expression: "person.dob.year"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('sh-dob_year_' + index)
      },
      attrs: {
        "data-vv-as": _vm.translations.text.year,
        "name": 'sh-dob_year_' + index
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(person.dob, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.years), function(year) {
      return _c('option', {
        key: year,
        domProps: {
          "value": year
        }
      }, [_vm._v(_vm._s(year))])
    })], 2)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('sh-dob_year_' + index)),
        expression: "errors.has('sh-dob_year_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('sh-dob_year_' + index)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "address"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.address))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.address),
        expression: "person.address"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('sh-address_' + index)
      },
      attrs: {
        "name": 'sh-address_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.address,
        "placeholder": _vm.translations.text.address
      },
      domProps: {
        "value": (person.address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "address", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('sh-address_' + index)),
        expression: "errors.has('sh-address_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('sh-address_' + index)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "address2"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.address2))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (''),
        expression: "''"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.address2),
        expression: "person.address2"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('sh-address2_' + index)
      },
      attrs: {
        "name": 'sh-address2_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.address2,
        "placeholder": _vm.translations.text.address2
      },
      domProps: {
        "value": (person.address2)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "address2", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('sh-address2_' + index)),
        expression: "errors.has('sh-address2_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('sh-address2_' + index)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "post_code"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.post_code))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.post_code),
        expression: "person.post_code"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('sh-post_code_' + index)
      },
      attrs: {
        "name": 'sh-post_code_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.post_code,
        "placeholder": _vm.translations.text.post_code
      },
      domProps: {
        "value": (person.post_code)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "post_code", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('sh-post_code_' + index)),
        expression: "errors.has('sh-post_code_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('sh-post_code_' + index)))])])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "city"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.city))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.city),
        expression: "person.city"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('sh-city_' + index)
      },
      attrs: {
        "name": 'sh-city_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.city,
        "placeholder": _vm.translations.text.city
      },
      domProps: {
        "value": (person.city)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "city", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('sh-city_' + index)),
        expression: "errors.has('sh-city_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('sh-city_' + index)))])])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "state_province"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.state_province))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.state_province),
        expression: "person.state_province"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('sh-state_province_' + index)
      },
      attrs: {
        "name": 'sh-state_province_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.state_province,
        "placeholder": _vm.translations.text.state_province
      },
      domProps: {
        "value": (person.state_province)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "state_province", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('sh-state_province_' + index)),
        expression: "errors.has('sh-state_province_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('sh-state_province_' + index)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "country"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.country))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select is-fullwidth"
    }, [_c('select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.country),
        expression: "person.country"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('sh-country_' + index)
      },
      attrs: {
        "data-vv-as": _vm.translations.text.country,
        "name": 'sh-country_' + index
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(person, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.filteredCountries), function(item, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": index
        }
      }, [_vm._v(_vm._s(item.name))])
    })], 2)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('sh-country_' + index)),
        expression: "errors.has('sh-country_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('sh-country_' + index)))])])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      class: {
        'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
      },
      attrs: {
        "for": "year_moved_to_address"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.year_moved_to_address))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select is-fullwidth"
    }, [_c('select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.year_moved_to_address),
        expression: "person.year_moved_to_address"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('sh-year_moved_to_address_' + index)
      },
      attrs: {
        "data-vv-as": _vm.translations.text.year_moved_to_address,
        "name": 'sh-year_moved_to_address_' + index
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(person, "year_moved_to_address", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.years), function(year) {
      return _c('option', {
        key: year,
        domProps: {
          "value": year
        }
      }, [_vm._v(_vm._s(year))])
    })], 2)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('sh-year_moved_to_address_' + index)),
        expression: "errors.has('sh-year_moved_to_address_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('sh-year_moved_to_address_' + index)))])])])])])
  }), _vm._v(" "), _vm._l((_vm.body.directors), function(person, index) {
    return _c('div', {
      key: 'direct-' + index,
      staticClass: "shareholders-directors"
    }, [_c('h2', [_vm._v(_vm._s(_vm.$t('director').tUpper()) + " - " + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "firstname"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.firstname))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|alpha_spaces'),
        expression: "'required|alpha_spaces'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.firstname),
        expression: "person.firstname"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('dir-firstname_' + index)
      },
      attrs: {
        "name": 'dir-firstname_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.firstname,
        "placeholder": _vm.translations.text.firstname
      },
      domProps: {
        "value": (person.firstname)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "firstname", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('dir-firstname_' + index)),
        expression: "errors.has('dir-firstname_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('dir-firstname_' + index)))])])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "lastname"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.lastname))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|alpha_spaces'),
        expression: "'required|alpha_spaces'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.lastname),
        expression: "person.lastname"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('dir-lastname_' + index)
      },
      attrs: {
        "name": 'dir-lastname_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.lastname,
        "placeholder": _vm.translations.text.lastname
      },
      domProps: {
        "value": (person.lastname)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "lastname", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('dir-lastname_' + index)),
        expression: "errors.has('dir-lastname_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('dir-lastname_' + index)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "dob"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.date_of_birth))])])]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label is-small",
      attrs: {
        "for": "dob_day"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.day))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select is-fullwidth"
    }, [_c('select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.dob.day),
        expression: "person.dob.day"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('dir-dob_day_' + index)
      },
      attrs: {
        "data-vv-as": _vm.translations.text.day,
        "name": 'dir-dob_day_' + index
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(person.dob, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.monthDayIndexes), function(day) {
      return _c('option', {
        key: day,
        domProps: {
          "value": day
        }
      }, [_vm._v(_vm._s(day))])
    })], 2)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('dir-dob_day_' + index)),
        expression: "errors.has('dir-dob_day_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('dir-dob_day_' + index)))])])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label is-small",
      attrs: {
        "for": "dob_month"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.month))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select is-fullwidth"
    }, [_c('select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.dob.month),
        expression: "person.dob.month"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('dir-dob_month_' + index)
      },
      attrs: {
        "data-vv-as": _vm.translations.text.month,
        "name": 'dir-dob_month_' + index
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(person.dob, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.translations.months), function(month, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": index
        }
      }, [_vm._v(_vm._s(month))])
    })], 2)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('dir-dob_month_' + index)),
        expression: "errors.has('dir-dob_month_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('dir-dob_month_' + index)))])])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label is-small",
      attrs: {
        "for": "dob_year"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.year))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select is-fullwidth"
    }, [_c('select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true,
          'is-over-18': person.dob.day + '-' + person.dob.month + '-' + person.dob.year
        }),
        expression: "{ required: true, 'is-over-18': person.dob.day + '-' + person.dob.month + '-' + person.dob.year }"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.dob.year),
        expression: "person.dob.year"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('dir-dob_year_' + index)
      },
      attrs: {
        "data-vv-as": _vm.translations.text.year,
        "name": 'dir-dob_year_' + index
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(person.dob, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.years), function(year) {
      return _c('option', {
        key: year,
        domProps: {
          "value": year
        }
      }, [_vm._v(_vm._s(year))])
    })], 2)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('dir-dob_year_' + index)),
        expression: "errors.has('dir-dob_year_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('dir-dob_year_' + index)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "address"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.address))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.address),
        expression: "person.address"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('dir-address_' + index)
      },
      attrs: {
        "name": 'dir-address_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.address,
        "placeholder": _vm.translations.text.address
      },
      domProps: {
        "value": (person.address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "address", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('dir-address_' + index)),
        expression: "errors.has('dir-address_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('dir-address_' + index)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "address2"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.address2))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (''),
        expression: "''"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.address2),
        expression: "person.address2"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('dir-address2_' + index)
      },
      attrs: {
        "name": 'dir-address2_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.address2,
        "placeholder": _vm.translations.text.address2
      },
      domProps: {
        "value": (person.address2)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "address2", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('dir-address2_' + index)),
        expression: "errors.has('dir-address2_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('dir-address2_' + index)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "post_code"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.post_code))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.post_code),
        expression: "person.post_code"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('dir-post_code_' + index)
      },
      attrs: {
        "name": 'dir-post_code_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.post_code,
        "placeholder": _vm.translations.text.post_code
      },
      domProps: {
        "value": (person.post_code)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "post_code", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('dir-post_code_' + index)),
        expression: "errors.has('dir-post_code_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('dir-post_code_' + index)))])])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "city"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.city))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.city),
        expression: "person.city"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('dir-city_' + index)
      },
      attrs: {
        "name": 'dir-city_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.city,
        "placeholder": _vm.translations.text.city
      },
      domProps: {
        "value": (person.city)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "city", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('dir-city_' + index)),
        expression: "errors.has('dir-city_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('dir-city_' + index)))])])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "state_province"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.state_province))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.state_province),
        expression: "person.state_province"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('dir-state_province_' + index)
      },
      attrs: {
        "name": 'dir-state_province_' + index,
        "type": "text",
        "data-vv-as": _vm.translations.text.state_province,
        "placeholder": _vm.translations.text.state_province
      },
      domProps: {
        "value": (person.state_province)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "state_province", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('dir-state_province_' + index)),
        expression: "errors.has('dir-state_province_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('dir-state_province_' + index)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      attrs: {
        "for": "country"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.country))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select is-fullwidth"
    }, [_c('select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.country),
        expression: "person.country"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('dir-country_' + index)
      },
      attrs: {
        "data-vv-as": _vm.translations.text.country,
        "name": 'dir-country_' + index
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(person, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.filteredCountries), function(item, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": index
        }
      }, [_vm._v(_vm._s(item.name))])
    })], 2)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('dir-country_' + index)),
        expression: "errors.has('dir-country_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('dir-country_' + index)))])])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('label', {
      staticClass: "label",
      class: {
        'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
      },
      attrs: {
        "for": "year_moved_to_address"
      }
    }, [_vm._v(_vm._s(_vm.translations.text.year_moved_to_address))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select is-fullwidth"
    }, [_c('select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (person.year_moved_to_address),
        expression: "person.year_moved_to_address"
      }],
      class: {
        'input': true, 'is-danger': _vm.errors.has('dir-year_moved_to_address_' + index)
      },
      attrs: {
        "data-vv-as": _vm.translations.text.year_moved_to_address,
        "name": 'dir-year_moved_to_address_' + index
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(person, "year_moved_to_address", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.years), function(year) {
      return _c('option', {
        key: year,
        domProps: {
          "value": year
        }
      }, [_vm._v(_vm._s(year))])
    })], 2)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('dir-year_moved_to_address_' + index)),
        expression: "errors.has('dir-year_moved_to_address_'+index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('dir-year_moved_to_address_' + index)))])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.tos_with_link),
      expression: "body.tos_with_link"
    }],
    staticClass: "agreements",
    class: {
      'is-danger': _vm.errors.has('include_account_in_bonus_program')
    },
    attrs: {
      "name": "tos_with_link",
      "type": "checkbox",
      "data-vv-as": _vm.translations.text.tos_with_link
    },
    domProps: {
      "checked": Array.isArray(_vm.body.tos_with_link) ? _vm._i(_vm.body.tos_with_link, null) > -1 : (_vm.body.tos_with_link)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.body.tos_with_link,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.body, "tos_with_link", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.body, "tos_with_link", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.body, "tos_with_link", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.translations.text.tos_with_link)
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tos_with_link')),
      expression: "errors.has('tos_with_link')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('tos_with_link')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.agree_terms_marketing),
      expression: "body.agree_terms_marketing"
    }],
    staticClass: "agreements",
    class: {
      'is-danger': _vm.errors.has('agree_terms_marketing')
    },
    attrs: {
      "name": "agree_terms_marketing",
      "type": "checkbox",
      "data-vv-as": _vm.translations.text.agree_terms_marketing
    },
    domProps: {
      "checked": Array.isArray(_vm.body.agree_terms_marketing) ? _vm._i(_vm.body.agree_terms_marketing, null) > -1 : (_vm.body.agree_terms_marketing)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.body.agree_terms_marketing,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.body, "agree_terms_marketing", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.body, "agree_terms_marketing", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.body, "agree_terms_marketing", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.translations.text.agree_terms_marketing)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "control privacy_data_text",
    domProps: {
      "innerHTML": _vm._s(_vm.translations.text.data_policy_text)
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "button is-dark is-pulled-left previous",
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('PreviousStep', $event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("previous")))])]), _vm._v(" "), _c('a', {
    staticClass: "button is-success is-pulled-right is-medium next",
    class: [_vm.isDisabled ? 'disabledButton' : ''],
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.validateCaptcha
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("complete")))])])], 2) : _vm._e(), _vm._v(" "), (_vm.showEUNoticeModal) ? _c('div', {
    staticClass: "modal small EUModal",
    class: {
      'is-active': _vm.showEUNoticeModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('important_information')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('important_information_text')))])])])]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://my.eurotrader.eu/en/register/partner"
    }
  }, [_vm._v(_vm._s(_vm.$t('continue').tTitle()))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71106c3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/register/Partner.vue
// module id = 785
// module chunks = 0